import { render } from "./djylResource.vue?vue&type=template&id=38cdcf1c&scoped=true"
import script from "./djylResource.vue?vue&type=script&lang=js"
export * from "./djylResource.vue?vue&type=script&lang=js"

import "./djylResource.vue?vue&type=style&index=0&id=38cdcf1c&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38cdcf1c"]])

export default __exports__